import styles from "../../../styles/service/product-details.module.scss";
import Step from "./Step";
import Drink from "./Drink";

const TYPES = {
  DRINK: "drink",
  STEP: "step",
  PIZZA: "pizza",
  FLAVOR: "flavor",
};

export default function ProductDetails({ localProduct, activeStep, onProductChange }) {
  if (!localProduct) return null;

  return (
    <div className={styles.productStep}>
      {TYPES.STEP === localProduct.type && (
        <Step
          localProduct={localProduct}
          activeStep={activeStep}
          onProductChange={onProductChange}
        />
      )}
      {TYPES.DRINK === localProduct.type && (
        <Drink
          localProduct={localProduct}
          activeStep={activeStep}
          onProductChange={onProductChange}
        />
      )}
    </div>
  );
}
